import "leaflet/dist/leaflet.css";
import { pdfjs } from "react-pdf";
import { React, useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import App from "./App";
import Alarms from "./pages/Alarms/Alarms";
import Sidebar from "./components/Sidebar/Sidebar";
import Devices from "./pages/Devices/Devices";
import UsersList from "./pages/Users/UsersList";
import TaskList from "./pages/TaskList/TaskList";
import Organisation from "./pages/Organisation/Organisation";
import UserDetail from "./pages/UserDetail/UserDetail";
import Reports from "./pages/Reports/Reports";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import NursingHomeDetail from "./pages/NursingHomeDetail/NursingHomeDetail";
import Login from "./pages/Login/Login";
import DeviceDetail from "./pages/DeviceDetail/DeviceDetail";
import OrganisationDetail from "./pages/OrganisationDetail/OrganisationDetail";
import SignIn from "./pages/SignIn/SignIn";
import LoginDetail from "./pages/LoginDetail/LoginDetail";

import { DashboardProvider } from "./context/dashboard-context";
import { AuthProvider } from "./context/auth-context";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";

import VitalDetail from "./components/VitalDetail/VitalDetail";
import Activities from "./pages/Activities/Activities";
import V46VitalsLog from "./pages/V46VitalsLog/V46VitalsLog";
import HobacareReportPage from "./pages/HobacareReport/HobacareReportPage";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

const AppRoutes = () => {
  const [userInfo, setUserInfo] = useState([]);

  // useEffect(() => {
  //   const token = Cookies.get("token");
  //   if (token !== undefined) {
  //     fetch(`https://app.vivasmartcare.com/api/profile/${token}`, {
  //       method: "GET",
  //       headers: { "Content-Type": "application/json" },
  //       credentials: "include",
  //     }).then((response) => {
  //       response.json().then((userInfo) => {
  //         setUserInfo(userInfo);
  //       });
  //     });
  //   }
  // }, []);

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <div className="main-wrapper">
              <Login />
            </div>
          }
        />
        <Route
          path="/homepage"
          element={
            <ProtectedRoute>
            <div className="main-wrapper">
              <App />
            </div>
            </ProtectedRoute>
          }
        />
        <Route
          path="/login"
          element={
            <div className="main-wrapper">
              <Login />
            </div>
          }
        />
        {/* Public cihaz rapor sayfası — auth gerektirmez, link ile paylaşılır */}
        <Route path="/cihaz-rapor" element={<HobacareReportPage />} />
        <Route
          path="/cihaz-rapor/:deviceId"
          element={<HobacareReportPage />}
        />
        <Route
          path="/nursing-home-detail/:homename"
          element={
            <ProtectedRoute>
              <NursingHomeDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/task-list"
          element={
            <ProtectedRoute>
            <>
              <Sidebar />
              <TaskList />
            </>
            </ProtectedRoute>
          }
        />
        <Route
          path="/alarms"
          element={
            <ProtectedRoute>
            <>
              <Sidebar />
              <Alarms />
            </>
            </ProtectedRoute>
          }
        />
        <Route
          path="/devices"
          element={
            <ProtectedRoute>
            <>
              <Sidebar />
              <Devices />
            </>
            </ProtectedRoute>
          }
        />
        <Route
          path="/devices/:id"
          element={
            <ProtectedRoute>
            <>
              <Sidebar />
              <DeviceDetail />
            </>
            </ProtectedRoute>
          }
        />
        <Route
          path="/viva02p/:id"
          element={
            <ProtectedRoute>
            <>
              <Sidebar />
              <VitalDetail />
            </>
            </ProtectedRoute>
          }
        />
        {/* Hobacare (Viva03D) cihaz detayı — VitalDetail içinde brand'e
            göre HobacareVitalDetail render edilir */}
        <Route
          path="/viva03d/:id"
          element={
            <ProtectedRoute>
            <>
              <Sidebar />
              <VitalDetail />
            </>
            </ProtectedRoute>
          }
        />
        <Route
          path="/viva02p/activities/:id"
          element={
            <ProtectedRoute>
            <>
              <Sidebar />
              <Activities />
            </>
            </ProtectedRoute>
          }
        />
        <Route
          path="/v46-vitals/:deviceId"
          element={
            <ProtectedRoute>
            <>
              <Sidebar />
              <V46VitalsLog />
            </>
            </ProtectedRoute>
          }
        />
        <Route
          path="/reports"
          element={
            <ProtectedRoute>
            <>
              <Sidebar />
              <Reports />
            </>
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="/organisation"
          element={
            <>
              <Sidebar />
              <Organisation />
            </>
          }
        />
        <Route
          path="/organisation/:id"
          element={
            <>
              <Sidebar />
              <OrganisationDetail />
            </>
          }
        /> */}
        <Route
          path="/user-list"
          element={
            <ProtectedRoute>
            <>
              <Sidebar />
              <UsersList />
            </>
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-list/:id"
          element={
            <ProtectedRoute>
            <>
              <Sidebar />
              <UserDetail />
            </>
            </ProtectedRoute>
          }
        />
        <Route path="/forget-password" element={<ForgotPassword />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route
          path="/login-detail"
          element={
            <ProtectedRoute>
            <>
              <Sidebar />
              <LoginDetail />
            </>
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
  <DashboardProvider>
    <AppRoutes />
  </DashboardProvider>
  </AuthProvider>
);
